'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var heading = require('./heading.js');
var text = require('./text.js');
var label = require('./label.js');
var textStyles = {
  heading: heading["default"],
  text: text["default"],
  label: label["default"]
};
exports["default"] = textStyles;